import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Users, Clock, HardHat } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmtEUR = (n) => `${Math.round(Number(n) || 0).toLocaleString('fr-FR')} EUR`;

export const GlobalLaborCostWidget = () => {
  const [data, setData] = useState(null);

  const fetch = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/projects/global-labor-cost`, { withCredentials: true });
      setData(res.data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  if (!data) return null;
  const { rows, totals } = data;
  const top = rows.filter(r => r.labor_cost_ht > 0).slice(0, 5);

  return (
    <div className="card" data-testid="global-labor-widget" style={{ padding: '0', overflow: 'hidden' }}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid #E2E2E6', background: 'linear-gradient(135deg, #002FA7 0%, #1E3A8A 100%)', color: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <HardHat size={24} weight="bold" />
            <h3 style={{ margin: 0, fontSize: '1rem' }}>Cout main-d'oeuvre global</h3>
          </div>
          <div style={{ display: 'flex', gap: '22px', fontSize: '0.85rem' }}>
            <div><span style={{ opacity: 0.8 }}>Chantiers actifs :</span> <b>{totals.project_count}</b></div>
            <div><Clock size={14} style={{ verticalAlign: 'middle' }} /> <b>{totals.total_hours}h</b></div>
          </div>
        </div>
        <div style={{ marginTop: '8px', fontSize: '2rem', fontWeight: '800', letterSpacing: '-0.5px' }}>
          {fmtEUR(totals.total_labor_cost_ht)}
        </div>
      </div>

      {top.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#9E9E9E', fontSize: '0.85rem' }}>
          Aucun cout de main-d'oeuvre enregistre pour le moment.
          <br />
          <span style={{ fontSize: '0.75rem' }}>Ajoutez un taux horaire a vos chantiers pour activer le calcul.</span>
        </div>
      ) : (
        <div>
          <div style={{ padding: '10px 18px', background: '#F8F9FB', fontSize: '0.75rem', color: '#5E5F66', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
            Top chantiers par cout MO
          </div>
          <table className="data-table" style={{ fontSize: '0.85rem', margin: 0 }}>
            <thead>
              <tr>
                <th>Chantier</th>
                <th style={{ textAlign: 'right' }}>Heures</th>
                <th style={{ textAlign: 'right' }}>Taux/h</th>
                <th style={{ textAlign: 'right' }}>Cout MO</th>
              </tr>
            </thead>
            <tbody>
              {top.map(r => (
                <tr key={r.id}>
                  <td style={{ fontWeight: '600' }}>{r.name}<div style={{ fontSize: '0.72rem', color: '#9E9E9E', fontWeight: '400' }}>{r.client_name || ''}</div></td>
                  <td style={{ textAlign: 'right' }}>{r.total_hours}h</td>
                  <td style={{ textAlign: 'right', color: '#5E5F66' }}>{r.hourly_rate ? `${r.hourly_rate} EUR` : '-'}</td>
                  <td style={{ textAlign: 'right', fontWeight: '700', color: '#002FA7' }}>{fmtEUR(r.labor_cost_ht)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
